import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label } from 'reactstrap';

import { getPlcSafetyTriggerById, updatePlcSafetyTrigger, getPlcSafetyEvents } from '../../store/actions';

class UpdatePlcSafetyTriggerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      trigger: this.props.trigger,
      action: this.props.trigger.action,
      eventId: String(this.props.trigger.event_id),
      skipIfBarrierWorking: !!this.props.trigger.skip_if_barrier_working,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getPlcSafetyTriggerById(this.state.user, this.state.trigger.id);
    this.props.getPlcSafetyEvents(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.triggerDetail && this.props.triggerDetail !== prevProps.triggerDetail) {
      const trigger = this.props.triggerDetail;
      this.setState({
        trigger,
        action: trigger.action,
        eventId: String(trigger.event_id),
        skipIfBarrierWorking: !!trigger.skip_if_barrier_working,
      });
    }

    const { updatePlcSafetyTriggerError, loadingUpdatePlcSafetyTrigger, messagePlcSafetyTrigger } = this.props;
    if (loadingUpdatePlcSafetyTrigger === false && prevProps.loadingUpdatePlcSafetyTrigger === true) {
      if (updatePlcSafetyTriggerError) {
        this.setState({
          popup: true,
          pop_msg: updatePlcSafetyTriggerError.message || 'Error al modificar el trigger',
          alertType: 'error',
        });
      } else if (messagePlcSafetyTrigger) {
        this.setState({ popup: true, pop_msg: 'Trigger modificado correctamente', alertType: 'correct' });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
    if (this.state.alertType === 'correct') this.props.history.push('/plcSafetyTriggers');
  }

  handleValidSubmit(event, values) {
    const user = this.state.user;
    values.id = this.state.trigger.id;
    values.action = this.state.action;
    values.event_id = Number(this.state.eventId);
    values.skip_if_barrier_working = this.state.skipIfBarrierWorking;
    values.token = user.token;
    this.props.updatePlcSafetyTrigger(values);
  }

  render() {
    const { trigger } = this.state;
    const events = this.props.events || [];
    const locked = !!trigger.has_active_causes;

    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Editar trigger PLC Safety')}</CardTitle>
            {locked ? (
              <Alert color="warning">
                {this.props.t(
                  'Este trigger tiene causas activas — no se puede editar hasta que se resuelvan (rearme + inicio de ciclo).',
                )}
              </Alert>
            ) : null}
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerName">{this.props.t('Nombre')}</Label>
                  <AvField
                    name="name"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    value={trigger.name}
                    disabled={locked}
                    id="triggerName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerTelegramType">{this.props.t('Identificador de telegrama')}</Label>
                  <AvField
                    name="telegram_type"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    value={trigger.telegram_type}
                    disabled={locked}
                    id="triggerTelegramType"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerAction">{this.props.t('Acción del telegrama')}</Label>
                  <AvInput
                    value={this.state.action}
                    name="action"
                    type="select"
                    className="form-control"
                    id="triggerAction"
                    disabled={locked}
                    onChange={(e) => this.setState({ action: e.target.value })}
                  >
                    <option value="0">{this.props.t('0 (activación)')}</option>
                    <option value="1">{this.props.t('1 (rearme)')}</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerElementPattern">{this.props.t('Patrón de elemento (SQL LIKE)')}</Label>
                  <AvField
                    name="element_pattern"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    value={trigger.element_pattern}
                    disabled={locked}
                    id="triggerElementPattern"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerEvent">{this.props.t('Evento')}</Label>
                  <AvInput
                    value={this.state.eventId}
                    name="event_id"
                    type="select"
                    className="form-control"
                    id="triggerEvent"
                    disabled={locked}
                    onChange={(e) => this.setState({ eventId: e.target.value })}
                  >
                    {events.map((ev) => (
                      <option key={ev.id} value={ev.id}>
                        {ev.name}
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup check className="mb-3">
                  <Label check htmlFor="triggerSkipIfBarrierWorking">
                    <Input
                      type="checkbox"
                      id="triggerSkipIfBarrierWorking"
                      checked={this.state.skipIfBarrierWorking}
                      disabled={locked}
                      onChange={(e) => this.setState({ skipIfBarrierWorking: e.target.checked })}
                    />{' '}
                    {this.props.t('Omitir si la posición ya está en modo trabajo (barrera deshabilitada)')}
                  </Label>
                  <div className="text-muted" style={{ fontSize: '0.85em' }}>
                    {this.props.t(
                      'Si está marcado, este trigger no creará ninguna causa ni parará nada cuando la posición afectada ya tenga la barrera deshabilitada por trabajo (BA1 enviado) — se confirma al PLC en silencio.',
                    )}
                  </div>
                </FormGroup>
              </Col>
              <Button color="secondary" type="submit" disabled={locked}>
                {this.props.t('Guardar cambios')}
              </Button>
            </AvForm>
            {this.state.popup ? (
              <SweetAlert
                type={this.state.alertType === 'correct' ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
                title={this.state.pop_msg}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { updatePlcSafetyTriggerError, messagePlcSafetyTrigger, loadingUpdatePlcSafetyTrigger } =
    state.updatePlcSafetyTrigger;
  const { trigger: triggerDetail } = state.getPlcSafetyTriggerById;
  const { events } = state.getPlcSafetyEvents;
  return { updatePlcSafetyTriggerError, messagePlcSafetyTrigger, loadingUpdatePlcSafetyTrigger, triggerDetail, events };
};

export default withRouter(
  connect(mapStateprops, { getPlcSafetyTriggerById, updatePlcSafetyTrigger, getPlcSafetyEvents })(
    withNamespaces()(UpdatePlcSafetyTriggerForm),
  ),
);
